import { render, staticRenderFns } from "./TravelAgencyCard.vue?vue&type=template&id=5651afc8&scoped=true"
import script from "./TravelAgencyCard.vue?vue&type=script&lang=js"
export * from "./TravelAgencyCard.vue?vue&type=script&lang=js"
import style0 from "./TravelAgencyCard.vue?vue&type=style&index=0&id=5651afc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5651afc8",
  null
  
)

export default component.exports